// extracted by mini-css-extract-plugin
module.exports = {"title":"index_title_BAOOf","block":"index_block_2biji","inner":"index_inner_3WmA6","form":"index_form_1QLyE"};